import { AbstractClient } from './AbstractClient';
import FormData from 'isomorphic-form-data';

/** The dec page Owl would compare a resynced policy against; `url` is signed for 90 min. */
export interface ResyncPreviousDocument {
  policyUuid: string;
  policyNumber: string;
  policyTypeId: number | null;
  expirationDate: string | null;
  declarationPageId: number;
  url: string | null;
}

export interface ResyncCredentials {
  clientUuid: string;
  submissionUuid: string;
  carrierSlug: string;
  username: string;
  password: string;
  additionalFields: Record<string, string | null | undefined>;
  previousDocuments?: ResyncPreviousDocument[];
  // All succeeded runs of the submission; picks the demo step (INS-1562). Absent before INS-1565.
  succeededRunCount?: number;
}

export class ResyncRunClient extends AbstractClient {
  getCredentials = this.createGetHandler<
    ResyncCredentials,
    { args: { runUuid: string } }
  >(({ runUuid }) => `/${runUuid}/credentials`);

  async uploadFile(
    runUuid: string,
    formData: FormData,
  ): Promise<{ key: string }> {
    const { data } = await this.postForm<{ key: string }>(
      `/${runUuid}/files`,
      formData,
    );
    return data;
  }

  async finalize(runUuid: string, formData: FormData) {
    return this.postForm(`/${runUuid}/finalize`, formData);
  }

  async fail(runUuid: string, formData: FormData) {
    return this.postForm(`/${runUuid}/fail`, formData);
  }

  // Without Accept: application/json Laravel answers a validation error with a 302.
  private postForm<T = unknown>(path: string, formData: FormData) {
    return this.client.post<T>(path, formData, {
      headers: { ...formData.getHeaders(), Accept: 'application/json' },
    });
  }
}
